(function() {
    'use strict';
    angular
        .module('jmrsignApp')
        .factory('AppAccount', AppAccount);

    AppAccount.$inject = ['$resource'];

    function AppAccount ($resource) {
        var resourceUrl =  'api/app-accounts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
